{
  "name": "SVM",
  "description": "",
  "version": "0.0.1",
  "sources": {
    "module": {
      "checksum": "",
      "location": {
        "npm": {
          "filePath": "dist/index.js",
          "packageName": "@avalabs/svm-module",
          "registry": "https://registry.npmjs.org"
        }
      }
    },
    "provider": {
      "checksum": "",
      "location": {
        "npm": {
          "filePath": "dist/provider/index.js",
          "packageName": "@avalabs/svm-module",
          "registry": "https://registry.npmjs.org"
        }
      }
    }
  },
  "network": {
    "chainIds": [
      "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
      "solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1",
      "solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z"
    ],
    "namespaces": ["solana"]
  },
  "cointype": "501",
  "permissions": {
    "rpc": {
      "dapps": true,
      "methods": ["solana_signTransaction", "solana_signAndSendTransaction", "solana_signMessage"],
      "nonRestrictedMethods": []
    }
  },
  "manifestVersion": "0.1"
}
